import store from 'store';

import AnnouncementsClient from './AnnouncementsClient';
import BalanceClient from './BalanceClient';
import BillingClient from './BillingClient';
import ColoClient from './ColoClient';
import ContractsClient from './ContractsClient';
import FeaturesClient from './FeaturesClient';
import HelpDeskClient from './HelpDeskClient';
import IamClient from './IamClient';
import InsightsClient from './InsightsClient';
import LocationsClient from './LocationsClient';
import MinerClient from './MinerClient';
import MollieClient from './MollieClient';
import PoolClient from './PoolClient';
import ProductsClient from './ProductsClient';
import SettingsClient from './SettingsClient';
import StripeClient from './StripeClient';
import TasksClient from './TasksClient';

let announcementsClient;
let balanceClient;
let billingClient;
let coloClient;
let contractsClient;
let featuresClient;
let helpDeskClient;
let iamClient;
let insightsClient;
let locationsClient;
let minerClient;
let mollieClient;
let poolClient;
let productsClient;
let settingsClient;
let stripeClient;
let tasksClient;

export async function initializeClients() {
  const state = store.getState();

  const {
    balanceBaseUrl,
    billingBaseUrl,
    coloBaseUrl,
    contractsBaseUrl,
    featuresBaseUrl,
    iamBaseUrl,
    locationsBaseUrl,
    minerBaseUrl,
    poolBaseUrl,
    productsBaseUrl
  } = state.config;

  announcementsClient = new AnnouncementsClient();
  balanceClient = new BalanceClient(balanceBaseUrl);
  billingClient = new BillingClient(billingBaseUrl);
  coloClient = new ColoClient(coloBaseUrl);
  contractsClient = new ContractsClient(contractsBaseUrl);
  featuresClient = new FeaturesClient(featuresBaseUrl);
  helpDeskClient = new HelpDeskClient();
  iamClient = new IamClient(iamBaseUrl);
  insightsClient = new InsightsClient();
  locationsClient = new LocationsClient(locationsBaseUrl);
  minerClient = new MinerClient(minerBaseUrl);
  // No dedicated mollieBaseUrl in config — same fallback convention as stripeClient below.
  mollieClient = new MollieClient();
  poolClient = new PoolClient(poolBaseUrl);
  productsClient = new ProductsClient(productsBaseUrl);
  // No dedicated stripeBaseUrl in config (same as coloBaseUrl/featuresBaseUrl above) — falls back
  // to the '/stripe' path prefix off the single REACT_APP_BASE_API_URL every client shares.
  settingsClient = new SettingsClient();
  stripeClient = new StripeClient();
  // No dedicated tasksBaseUrl in config — same fallback convention as stripeClient above.
  tasksClient = new TasksClient();
}

export {
  announcementsClient,
  balanceClient,
  billingClient,
  coloClient,
  contractsClient,
  featuresClient,
  helpDeskClient,
  iamClient,
  insightsClient,
  locationsClient,
  minerClient,
  mollieClient,
  poolClient,
  productsClient,
  settingsClient,
  stripeClient,
  tasksClient
};
